import React, { ReactNode, createContext, useContext } from 'react';

/** `{ [entryId]: amount | null }` — `null` means the offer is currently suspended. */
type Offers = Record<string, number | null>;

const EMPTY_OFFERS: Offers = {};

const CashOutOffersContext = createContext<Offers | undefined>(undefined);

/** Distributes batched cash-out offers to the entry cards below; the owning list owns the query and feeds them in. */
export const CashOutOffersProvider = ({ offers, children }: { offers?: Offers; children: ReactNode }) => (
    <CashOutOffersContext.Provider value={offers ?? EMPTY_OFFERS}>{children}</CashOutOffersContext.Provider>
);

/** A single entry's cash-out offer from the batched list query. `null` while loading/suspended. */
export const useCashOutOffer = (entryId: string): number | null => {
    const offers = useContext(CashOutOffersContext);
    if (offers === undefined) {
        throw new Error('useCashOutOffer must be used within a CashOutOffersProvider');
    }
    return offers[entryId] ?? null;
};
